module.exports = __webpack_public_path__ + "img/AdobeStock_44428934.91ab956d.jpeg";